const HELPSCOUT_EMAIL = "info@tourism.tech";
const phoneNumberRegex =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

export { HELPSCOUT_EMAIL, phoneNumberRegex };
